import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { ActionsUnion } from '../types';
import { GlobalNotification } from './types';

export const Actions = {
  spawnGlobalNotification: (notification: GlobalNotification) => createAction(ActionTypes.SPAWN_GLOBAL_NOTIFICATION, notification),
  dismissGlobalNotification: (notification: GlobalNotification) => createAction(ActionTypes.DISMISS_GLOBAL_NOTIFICATION, notification)
};

export type GlobalNotificationsActions = ActionsUnion<typeof Actions>;
